<template>
  <div class="home">

    <!-- Слайдер -->
    <div class="slider">
      <v-container fluid>
        <Widget position="MainSlider"/>
      </v-container>
    </div>

    <v-container>
      <Widget position="block"/>
    </v-container>
  </div>
</template>

<script>
import Widget from '@/components/app/Widget'

export default {
  components: {
    Widget
  },
  name: 'Home'
}
</script>
